"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiBackground = void 0;
var _pixi = require("pixi.js");
var _pixiGame = require("@dragon/pixi-game");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiBackground = exports.PixiBackground = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiBackground(componentName, type, forceSize) {
    var _this;
    var bgTextureName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'bg1';
    _classCallCheck(this, PixiBackground);
    _this = _callSuper(this, PixiBackground, [componentName]);
    _defineProperty(_this, "sprite", void 0);
    _defineProperty(_this, "forceSize", void 0);
    _defineProperty(_this, "type", void 0);
    _defineProperty(_this, "spriteOriginalSize", void 0);
    _defineProperty(_this, "blurFilter", void 0);
    _defineProperty(_this, "textures", void 0);
    _defineProperty(_this, "currentFeatureSet", void 0);
    _defineProperty(_this, "rainTimeout", void 0);
    _defineProperty(_this, "inFreespin", void 0);
    _defineProperty(_this, "freeSpinStart", function () {});
    _defineProperty(_this, "freeSpinEnd", function () {});
    _this.forceSize = forceSize;
    _this.type = type;
    _this.textures = [_pixi.Texture.from(bgTextureName)];
    _this.sprite = new _pixi.Sprite(_this.textures[0]);
    _this.addChild(_this.sprite);
    _this.spriteOriginalSize = {
      x: _this.sprite.width,
      y: _this.sprite.height
    };

    // we create a blurred version of the back ground.
    /*  var tex = RenderTexture.create({ width: this.sprite.width, height: this.sprite.height });
      var spr = new Sprite(Texture.from('bg1'));
      let blurFilter = new filters.BlurFilter();
      spr.filters = [blurFilter];
      blurFilter.blur = 7;
      blurFilter.blurY = 7;
      this.application.renderer.render(spr, tex);
      spr.destroy()
      Texture.addToCache(tex, "bg1Blurred")  // maybe we should remove?*/
    return _this;
  }
  _inherits(PixiBackground, _PixiGameComponent);
  return _createClass(PixiBackground, [{
    key: "onResize",
    value: function onResize(c) {
      var sp = this.forceSize ? this.forceSize : this.spriteOriginalSize;
      var winratio = c.width / c.height;
      var spratio = sp.x / sp.y;
      var scale = 1;
      var pos = {
        x: 0,
        y: 0
      };
      if (this.type == 'cover' ? winratio > spratio : winratio < spratio) {
        //photo is wider than background
        scale = c.width / sp.x;
        pos.y = -(sp.y * scale - c.height) / 2;
      } else {
        //photo is taller than background
        scale = c.height / sp.y;
        pos.x = -(sp.x * scale - c.width) / 2; //+250
      }
      this.sprite.scale.set(scale, scale);
      this.sprite.position.set(pos.x, pos.y);
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiBackground.js.map